export default "__VITE_ASSET__8a4a1426__"